//@flow
import * as React from 'react';
import { translate, type TFunction } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { FetchStatusEnum } from 'common/enums/FetchEnum';
import Loader from 'common/components/core/loader/Loader';
import APIFetcher from 'common/components/core/api_fetcher';
import { RetrySnackbar } from 'common/components/core/snackbar';
import { Redirect } from 'react-router-dom';
import PersonnelActions from 'common/redux/actions/personnel';

type OwnProps = { children: React.Node };
type FetcherProps = {
    t: TFunction,
    username: string,
    fetchMinimalPersonnel: ({ username: string }) => void,
    ...OwnProps
};

const MinimalPersonnelFetchHOC = Component => {
    const MinimalPersonnelFetcher = (props: FetcherProps) => {
        const { fetchMinimalPersonnel, t, username } = props;
        return (
            <APIFetcher params={{ username }} apiAction={fetchMinimalPersonnel}>
                {({ error, status, onRetry }) => {
                    if (status === FetchStatusEnum.Failure) {
                        if (
                            error.statusCode === null ||
                            error.statusCode === undefined ||
                            error.statusCode > 499
                        ) {
                            // show retry for internet/5xx
                            return (
                                <RetrySnackbar
                                    errorMessage={t(
                                        'translations:genericDataFetchError'
                                    )}
                                    active
                                    onClick={onRetry}
                                />
                            );
                        }
                        // redirect to login if 4xx
                        return <Redirect to="/login" />;
                    }
                    if (status === FetchStatusEnum.Loading) {
                        return <Loader solid active absolute />;
                    }
                    return <Component {...props} />;
                }}
            </APIFetcher>
        );
    };

    const mapDispatchToProps = {
        fetchMinimalPersonnel: PersonnelActions.fetchMinimalPersonnel
    };

    return (compose(
        connect(null, mapDispatchToProps),
        translate('settings')
    )(MinimalPersonnelFetcher): React.AbstractComponent<OwnProps>);
};

export default MinimalPersonnelFetchHOC;
